module.exports = __webpack_public_path__ + "img/circle3.797f31b4.png";